<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.2045 5.2045C5.64384 4.76517 6.35616 4.76517 6.7955 5.2045L12 10.409L17.2045 5.2045C17.6438 4.76517 18.3562 4.76517 18.7955 5.2045C19.2348 5.64384 19.2348 6.35616 18.7955 6.7955L13.591 12L18.7955 17.2045C19.2348 17.6438 19.2348 18.3562 18.7955 18.7955C18.3562 19.2348 17.6438 19.2348 17.2045 18.7955L12 13.591L6.7955 18.7955C6.35616 19.2348 5.64384 19.2348 5.2045 18.7955C4.76517 18.3562 4.76517 17.6438 5.2045 17.2045L10.409 12L5.2045 6.7955C4.76517 6.35616 4.76517 5.64384 5.2045 5.2045Z" fill="#667488"/>
    </svg>
</template>
<script>
export default {

}
</script>
